import { EntityTypes, IBrief, IClassroom, IGroupSpace, IUserResource } from "@sol/sdk";
import { IApiMutationFunction, createApiMutationHook } from "@sol/sdk/utils/api";
import { mapRelationalFilterToIRI, mapRelationalValueAsIRI } from "@sol/sdk/utils/filters";

export type IGroupSpaceCreateMutationParameters = {
    uuid: string;
    classroom: IClassroom;
    brief: IBrief;
    learners: IUserResource[];
};

export type IGroupSpaceCreateMutationResult = IGroupSpace;

export const groupSpaceCreateMutation: IApiMutationFunction<IGroupSpaceCreateMutationParameters> = ({
    classroom,
    brief,
    learners,
    ...data
}) => {
    return {
        method: "POST",
        url: `/group_spaces`,
        data: {
            ...data,
            classroom: mapRelationalValueAsIRI(EntityTypes.CLASSROOM, classroom),
            brief: mapRelationalValueAsIRI(EntityTypes.BRIEF, brief),
            learners: mapRelationalFilterToIRI(EntityTypes.USER, learners),
            ...data,
        },
    };
};

export const useGroupSpaceCreateMutation = createApiMutationHook<
    IGroupSpaceCreateMutationParameters,
    IGroupSpaceCreateMutationResult
>(groupSpaceCreateMutation);
